module.exports = __webpack_public_path__ + "static/media/ic_profile.d3d7ef95.png";